module.exports = __webpack_public_path__ + "static/media/4bba3172-358a-44cf-8361-a9557cc37496.30e25e8f.JPG";